import React from 'react';
import PropTypes from 'prop-types';
import { flowRight } from 'lodash';
import ensureAuth from '../../hoc/ensure-auth';
import { connect } from '../../../common/components/runtime-context';
import withTranslate from '../../../common/components/with-translate/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import classNames from 'classnames';
import { DISCUSSION } from '@wix/communities-forum-client-commons/dist/src/constants/post-types';
import { CREATE_NEW_POST } from '../../constants/interactions';
import CreatePostHandler from '../../containers/create-post-handler';
import { CommentIcon } from '../icons/comment-icon';
import Button from '../button';
import ProtectedButton from '../../containers/protected-button';
import styles from './create-dicussion-button.scss';

const ButtonSecure = ensureAuth(Button);

const DiscussionPostButton = ({
  categorySlug,
  t,
  isSmall = true,
  isExtended,
  contentFontClassName,
  className,
  userEventsClickCreatePost,
}) => {
  const savedAction = {
    action: CREATE_NEW_POST,
    args: [categorySlug ? `/${categorySlug}/create-post` : '/create-post'],
  };

  const reportBI = () => {
    userEventsClickCreatePost(DISCUSSION);
  };

  const renderExtended = () => (
    <ProtectedButton
      actionDetails={savedAction}
      role="menuitem"
      className={styles.button}
      data-hook="create-post"
      reportBI={reportBI}
    >
      <div
        className={classNames(
          'forum-text-color',
          'button-hover-color',
          'button-hover-fill',
          'button-hover-stroke',
          'forum-icon-fill',
          'forum-icon-stroke',
          contentFontClassName,
          styles.container,
          className,
        )}
      >
        <div className={styles.icon}>
          <CommentIcon />
        </div>
        <div className={styles.text}>
          <span className={styles.title}>{t('create-post-button.create-new-post-title')}</span>
          <span className={styles.info}>{t('create-post-button.create-new-post-info')}</span>
        </div>
      </div>
    </ProtectedButton>
  );

  return (
    <CreatePostHandler categorySlug={categorySlug} postType={DISCUSSION}>
      {isExtended ? (
        renderExtended()
      ) : (
        <ButtonSecure
          data-hook="create-post"
          actionDetails={savedAction}
          isSmall={isSmall}
          reportBI={reportBI}
        >
          {t('create-post-button.create-new-post')}
        </ButtonSecure>
      )}
    </CreatePostHandler>
  );
};

DiscussionPostButton.propTypes = {
  categorySlug: PropTypes.string,
  t: PropTypes.func.isRequired,
  isExtended: PropTypes.bool,
  isSmall: PropTypes.bool,
  contentFontClassName: PropTypes.string,
  className: PropTypes.string,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  userEventsClickCreatePost: actions.userEventsClickCreatePost,
});

export default flowRight(
  withTranslate,
  withFontClassName,
  connect(mapRuntimeToProps),
)(DiscussionPostButton);
